import ApiService from './../api/ApiService';
import Config from "./../constants/Config"
import Urls from './../api/Urls';
import Tour, { TourType, TourLine, TourTicket, TourSurchargeCategories, TagSKUVWTYPE } from './../models/Tour';
import { parseTourListReponseParams, getMomentDate, getContentLanguage } from './../utils/commonUtils';
import moment from 'moment';
import { get, orderBy, omit } from 'lodash';
import { dummyTourTicket } from '../constants/Dummies';


export function getTours(params) {
    return new ApiService({
        baseURL: Config.API_TOUR,
        endpoint: Urls.TOUR_LIST,
        params: params,
        parser: toursDataParser,
    }).get();
}

export function getAllTours(params) {
    return new ApiService({
        baseURL: Config.API_TOUR,
        endpoint: Urls.TOUR_ALL_LIST,
        params: params,
        parser: toursDataParser,
        headers: {
            'accept-language': getContentLanguage() === 'all' ? 'vi-VN' : getContentLanguage()
        }
    }).get();
}

export function exportExcel(params) {
    return new ApiService({
        baseURL: Config.API_TOUR,
        endpoint: Urls.TOUR_EXPORT_EXCEL,
        isDownload: true,
        params: params,
    }).get();
}

export function cloneTourItem(id, lengthOfStay, isCopyTourTickets) {
    return new ApiService({
        baseURL: Config.API_TOUR,
        endpoint: Urls.TOUR_CLONE_EXCEL
    }).post({ tourId: id, lengthOfStay, isCopyTourTickets });
}

export function getTourDetail(id) {
    return new ApiService({
        baseURL: Config.API_TOUR,
        endpoint: Urls.TOUR_DETAIL,
        endpointParams: { id },
        parser: (data) => new Tour(data.data),
    }).get();
}

export function createTourDetail(tour) {
    return new ApiService({
        baseURL: Config.API_TOUR,
        endpoint: Urls.TOUR_CREATE,
        // parser: (data) => new Tour(data.tour),
    }).post(tour.export());
}

export function updateTourDetail(tour) {
    return new ApiService({
        baseURL: Config.API_TOUR,
        endpoint: Urls.TOUR_CREATE,
        parser: (data) => new Tour(data.tour),
    }).put(tour.export());
}

export function deleteTourDetail(tour) {
    return new ApiService({
        baseURL: Config.API_TOUR,
        endpoint: Urls.TOUR_DELETE,
        endpointParams: { id: tour.id },
    }).delete();
}

// TOUR TYPES

export function getAllTourTypes() {
    return new ApiService({
        baseURL: Config.API_TOUR,
        endpoint: Urls.TOUR_TYPE_ALL,
        parser: data => (data.data || []).map(item => new TourType(item)),
    }).get();
}

export function createTourType(tourType) {
    return new ApiService({
        baseURL: Config.API_TOUR,
        endpoint: Urls.TOUR_TYPE_CREATE,
        parser: (data) => new TourType({ id: data.data.tourTypeId, name: tourType.name }),
    }).post(tourType.export());
}

export function updateTourType(tourType) {
    return new ApiService({
        baseURL: Config.API_TOUR,
        endpoint: Urls.TOUR_TYPE_CREATE,
        parser: (data) => new TourType({ id: get(data, 'data.tourTypeId') || tourType.id, name: tourType.name }),
    }).put(tourType.export());
}

export function deleteTourType(tourType) {
    return new ApiService({
        baseURL: Config.API_TOUR,
        endpoint: Urls.TOUR_TYPE_DETAIL,
        endpointParams: { id: tourType.id },
    }).delete();
}

// TOUR SURCHARGE CATEGORIES

export function getAllSurchargeCategories() {
    return new ApiService({
        baseURL: Config.API_TOUR,
        endpoint: Urls.TOUR_SURCHARGE_CATEGORIES,
        parser: data => (data.data.result || []).map(item => new TourSurchargeCategories(item)),
    }).get();
}

export function createSurchargeCategories(surchargeCategories) {
    return new ApiService({
        baseURL: Config.API_TOUR,
        endpoint: Urls.TOUR_SURCHARGE_CATEGORIES,
        parser: () => new TourSurchargeCategories({ name: surchargeCategories.name }),
    }).post({ name: surchargeCategories.name });
}

//TOUR LINES

export function getTourLinesByTour(tourId, params, isEndpointAdmin = true) {
    return new ApiService({
        baseURL: Config.API_TOUR,
        endpoint: isEndpointAdmin ? Urls.TOUR_LINE_LIST_BY_TOUR_ID_ADMIN : Urls.TOUR_LINE_LIST_BY_TOUR_ID,
        params: params,
        endpointParams: { tour_id: tourId },
        parser: tourLinesDataParser,
    }).get();
}

export function getTourLineDetail(id) {
    return new ApiService({
        baseURL: Config.API_TOUR,
        endpoint: Urls.TOUR_LINE_DETAIL,
        endpointParams: { id },
        parser: (data) => new TourLine(data.data),
    }).get();
}

export function createTourLine(tourLine) {
    return new ApiService({
        baseURL: Config.API_TOUR,
        endpoint: Urls.TOUR_LINE_CREATE,
        parser: (data) => new TourLine(data.data),
    }).post(tourLine);
}

export function getTourLineTickets(params) {
    return new ApiService({
        baseURL: Config.API_TOUR,
        endpoint: Urls.TOUR_LINE_TICKET_LIST,
        params: params,
        // parser: tourLinesDataParser,
    }).get();
}

export function createTourLineBulk(data) {
    const dataTourLineBulk = omit(data, ['selectedTourTickets']);
    return new ApiService({
        baseURL: Config.API_TOUR,
        endpoint: Urls.TOUR_LINE_BULK_CREATE,
        parser: tourLinesDataParser,
    }).post({ ...dataTourLineBulk, steps: data.step });
}

export function updateTourLine(tourLine) {
    return new ApiService({
        baseURL: Config.API_TOUR,
        endpoint: Urls.TOUR_LINE_CREATE,
        parser: (data) => new TourLine(data.data),
    }).put(tourLine.export());
}

export function deleteTourLine(tourLine) {
    return new ApiService({
        baseURL: Config.API_TOUR,
        endpoint: Urls.TOUR_LINE_DETAIL,
        endpointParams: { id: tourLine.id },
    }).delete();
}

export function deleteTourLinesBulk(ids) {
    return new ApiService({
        baseURL: Config.API_TOUR,
        endpoint: Urls.TOUR_LINE_BULK_DELETE,
        headers: {
            'Content-Type': 'application/json-patch+json',
        },
    }).delete({ ids });
}

export function updateOrderTourItem(tourItem) {
    return new ApiService({
        baseURL: Config.API_TOUR,
        endpoint: Urls.TOUR_LINE_SALE_HISTORY,
    }).put(tourItem.export ? tourItem.export() : tourItem);
}

//TRANSLATE
export function createTourTranslate(tour) {
    return new ApiService({
        baseURL: Config.API_TOUR,
        endpoint: Urls.TOUR_TRANSLATE_CREATE,
    }).post(tour.export(true).translate());
}

export function updateTourTranslate(tour) {
    return new ApiService({
        baseURL: Config.API_TOUR,
        endpoint: Urls.TOUR_TRANSLATE_UPDATE,
    }).put(tour.export(true).translate());
}

export function deleteTourTranslate(id) {
    return new ApiService({
        baseURL: Config.API_TOUR,
        endpoint: Urls.TOUR_TRANSLATE_DELETE,
        endpointParams: { id },
    }).delete();
}

/* Tourline ticket */

export function getTourItemTickets(tourlineId) {
    return new ApiService({
        baseURL: Config.API_TOUR,
        endpoint: Urls.TOUR_ITEM_TICKETS,
        endpointParams: { tourlineId },
        // parser: surchargeDataParser,
    }).get();
}

export function getTourItemTicket(id) {
    return new ApiService({
        baseURL: Config.API_TOUR,
        endpoint: Urls.TOUR_ITEM_TICKET_GET_DETAIL,
        endpointParams: { id },
        // parser: (data) => new OrderSurchargeItem(data.data),
    }).get();
}

export function createTourItemTicket(itemTicket) {
    return new ApiService({
        baseURL: Config.API_TOUR,
        endpoint: Urls.TOUR_ITEM_TICKET_DETAIL_ACTION,
        // parser: (data) => new OrderSurchargeItem(data.surcharge),
    }).post(itemTicket);
}

export function updateTourItemTicket(itemTicket) {
    return new ApiService({
        baseURL: Config.API_TOUR,
        endpoint: Urls.TOUR_ITEM_TICKET_DETAIL_ACTION,
        // parser: (data) => new OrderSurchargeItem(data.surcharge),
    }).put(itemTicket);
}

export function deleteTourItemTicket(ticketId) {
    return new ApiService({
        baseURL: Config.API_TOUR,
        endpoint: Urls.TOUR_ITEM_TICKET_DETAIL_DELETE,
        endpointParams: { id: ticketId }
    }).delete();
}


// TOUR TICKET IN DETAIL

export function getDetailTourTickets(params) {
    return new ApiService({
        baseURL: Config.API_TOUR,
        endpoint: Urls.DETAIL_TOUR_TICKET_LIST,
        params: params,
        parser: tourTicketsDataParser,
    }).get();
}

export function getDetailTourTicketDetail(id) {
    return new ApiService({
        baseURL: Config.API_TOUR,
        endpoint: Urls.DETAIL_TOUR_TICKET_DETAIL,
        endpointParams: { id },
        parser: (data) => new TourTicket(data.data),
    }).get();
}

export function createDetailTourTicketDetail(tourTicket) {
    return new ApiService({
        baseURL: Config.API_TOUR,
        endpoint: Urls.DETAIL_TOUR_TICKET_CREATE,
        parser: (response) => {
            const data = response.data || {};
            const createdTicket = new TourTicket({
                ...tourTicket,
                ...data,
                id: data.tourTicketId || data.id,
            }, true);
            createdTicket.languageCode = data.languageCode || tourTicket.languageCode;
            return createdTicket;
        },
    }).post(tourTicket.export());
}

export function updateDetailTourTicketDetail(tourTicket) {
    const payload = {
        ...tourTicket.export(),
        code: tourTicket.code,
    };
    return new ApiService({
        baseURL: Config.API_TOUR,
        endpoint: Urls.DETAIL_TOUR_TICKET_CREATE,
        parser: (data) => new Tour(data.data),
    }).put(payload);
}

export function deleteDetailTourTicketDetail(tourTicket) {
    return new ApiService({
        baseURL: Config.API_TOUR,
        endpoint: Urls.DETAIL_TOUR_TICKET_DELETE,
        endpointParams: { id: tourTicket.id },
    }).delete();
}

export function createDetailTourTicketTranslate(tourTicket) {
    return new ApiService({
        baseURL: Config.API_TOUR,
        endpoint: Urls.DETAIL_TOUR_TICKET_TRANSLATE_CREATE,
    }).post(tourTicket.export(true).translate());
}

export function updateDetailTourTicketTranslate(tourTicket) {
    return new ApiService({
        baseURL: Config.API_TOUR,
        endpoint: Urls.DETAIL_TOUR_TICKET_TRANSLATE_UPDATE,
    }).put(tourTicket.export(true).translate());
}

export function deleteDetailTourTicketTranslate(id) {
    return new ApiService({
        baseURL: Config.API_TOUR,
        endpoint: Urls.DETAIL_TOUR_TICKET_TRANSLATE_DELETE,
        endpointParams: { id },
    }).delete();
}

export function getAllTagSKUVW() {
    return new ApiService({
        baseURL: Config.API_CMS,
        endpoint: Urls.VINWONDER_SKU_TAGS_LIST,
        parser: data => (data.data.result || []).map(item => new TagSKUVWTYPE(item)),
    }).get();
}

export function createTagSKUVW(tagSKUVW) {
    return new ApiService({
        baseURL: Config.API_CMS,
        endpoint: Urls.VINWONDER_SKU_TAGS_CREATE,
        parser: (data) => new TagSKUVWTYPE(data.data),
    }).post(tagSKUVW);
}

export function updateTagSKUVW(tagSKUVW) {
    return new ApiService({
        baseURL: Config.API_CMS,
        endpoint: Urls.VINWONDER_SKU_TAGS_EDIT,
        parser: (data) => new TagSKUVWTYPE(data.data),
    }).put(tagSKUVW);
}

export function deleteTagSKUVW(tagSKUVW) {
    return new ApiService({
        baseURL: Config.API_CMS,
        endpoint: `${Urls.VINWONDER_SKU_TAGS_DELETE}/${tagSKUVW.id}`,
    }).delete();
}

const toursDataParser = (data) => data.data ? ({
    tours: (data.data.result || []).map(item => new Tour(item)),
    ...parseTourListReponseParams(data.data),
}) : { tours: [] };

const tourLinesDataParser = (data) => data.data ? ({
    tourLines: orderBy((get(data, 'data.items') || []).map(item => new TourLine(item)), [item => item.departureDate && item.departureDate.toDate().getTime()], ['asc']),
    tourLineDateRanges: getTourLineDateRanges(data),
    fromDate: get(data, 'data.queryFromDate') && getMomentDate(data.data.queryFromDate),
    toDate: get(data, 'data.queryToDate') && getMomentDate(data.data.queryToDate),
}) : { tourLines: [] };

const getTourLineDateRanges = (data) => {
    let months = (get(data, 'data.months') || []).filter(item => item.count > 0);
    months = orderBy(months, [item => moment().set({ 'year': item.year, 'month': item.month - 1 }).startOf('month').toDate().getTime()], ['asc'])
    return months.map(item => ({
        ...item, dateRange: [
            moment().set({ 'year': item.year, 'month': item.month - 1 }).startOf('month'),
            moment().set({ 'year': item.year, 'month': item.month - 1 }).endOf('month'),
        ]
    }))
}


const tourTicketsDataParser = (data) => data.data ? ({
    tourTickets: (data.data?.result || []).map(item => new TourTicket(item)),
    ...parseTourListReponseParams(data.data),
}) : { tourTickets: [] };
